const userAlertsModule = {
  state: {
    items: null,
    pagination: null,
    notifications: {}
  },
  mutations: {
    setUserAlerts (state, data) {
      state.items = data
    },
    setUserAlertsPagination (state, data) {
      state.pagination = data
    },
    setUserAlert (state, data) {
      state[data.id] = data
    },
    setUserAlertNotifications (state, data) {
      state.notifications[data.id] = data.notifications
    },
  },
  getters: {
    getUserAlerts: (state) => {
      return state.items
    },
    getUserAlertsPagination: (state) => {
      return state.pagination
    },
    getUserAlertById: (state) => (id) => {
      return state[id]
    },
    getUserAlertNotifications: (state) => (id) => {
      return state.notifications[id]
    },
  }
}

export default userAlertsModule



// WEBPACK FOOTER //
// ./src/store/modules/user_alerts.js